import { useMemo } from 'react'

import { useGetUserDomains } from '../../DomainPresentation/api/getUserDomains'
import { DomainPixelObject, useSetFacebookPixelsToDomains } from '../api/setFacebookPixelsToDomains'

import { Pixel } from '../models'

// In case user just one domain, we can automatically assign all the selected pixels to domain
// Hook returns function that checks if user has only one domain and if so, it assigns all the provided pixels to that domain
export const useSetSingularDomainToPixels = ({ accountId }: { accountId: number }) => {
  const { data: domainsData } = useGetUserDomains({})

  const domains = useMemo(() => (!domainsData?.domains ? [] : domainsData.domains), [domainsData])

  const isSingularDomain = domains.length === 1

  const selectedPixelToDomain = (domainId: number, pixels: Pixel[]) =>
    pixels.reduce<DomainPixelObject[]>((result, px) => {
      if (px.selected) {
        result.push({ pixelId: px.id, domainId: domainId })
      }
      return result
    }, [])

  const { mutate } = useSetFacebookPixelsToDomains()

  const checkAssignPixelsToDomain = (pixels: Pixel[], onSuccessCallback?: () => void) => {
    if (isSingularDomain && pixels.length && domains[0].id) {
      mutate(
        {
          connectionId: accountId,
          pixels: selectedPixelToDomain(domains[0].id, pixels),
        },
        {
          onSuccess: (data) => {
            if (!(data instanceof Error) && onSuccessCallback) {
              onSuccessCallback()
            }
          },
        }
      )
    }
  }
  return { isSingularDomain, checkAssignPixelsToDomain }
}
